import { memo, useMemo, useState } from "react";

import { Popover } from "antd";
import styled from "styled-components";

import { ToolbarButton } from "components/base";
import CollapseVerticalIcon from "components/icons/CollapseVertical";

import { INormalizeBySetting } from "../../../models/normalizeBy";
import NormalizeBySettings from "./NormalizeBySettings";

interface NormalizeByToggleProps {
  value?: INormalizeBySetting;
  onChange: (next: INormalizeBySetting) => void;
  hasFeatures?: boolean;
  testIdPrefix?: string;
  displayBorder?: boolean;
}

const NormalizeByToggleBase = ({
  value,
  onChange,
  hasFeatures = true,
  testIdPrefix = "mlNormalizeToggle",
  displayBorder = false
}: NormalizeByToggleProps) => {
  const [visible, setVisible] = useState(false);

  const isNormalizeActive = useMemo(() => !!value?.useNormalizeBy, [value]);

  if (!hasFeatures) {
    return null;
  }

  return (
    <Popover
      arrowPointAtCenter
      content={<NormalizeBySettings value={value} onChange={onChange} />}
      onOpenChange={(open) => setVisible(open)}
      open={visible}
      overlayClassName="normalize-popover"
      placement="left"
      trigger="click">
      <StyledToolbarButton
        displayBorder={displayBorder}
        active={isNormalizeActive}
        data-testid={
          isNormalizeActive ? `${testIdPrefix}Active` : `${testIdPrefix}Inactive`
        }
        icon={<CollapseVerticalIcon size={18} />}
        tooltipText="Normalize"
        styleKey="mlFeature"
      />
    </Popover>
  );
};

export default memo(NormalizeByToggleBase);

const StyledToolbarButton = styled(ToolbarButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  border: ${(props) => (props.displayBorder ? "1px solid #d9d9d9" : "none")};

  &:hover,
  &:not(:disabled):hover {
    border-color: var(--color-primary);
    color: var(--color-primary);
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px;
    background: rgba(0, 0, 0, 0.018);
  }

  &.active {
    border-color: var(--color-primary);

    &:hover {
      color: var(--color-text);
    }
  }
`;
